import { render, staticRenderFns } from "./PowerTranslateContent.vue?vue&type=template&id=d0c52692&scoped=true"
import script from "./PowerTranslateContent.vue?vue&type=script&lang=js"
export * from "./PowerTranslateContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c52692",
  null
  
)

export default component.exports